import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { media, spacing } from 'ui';
import { getSelectedPlace } from 'selectors';
import { ENVIRONMENT } from '../constants';

// La roue de debug (containers/Debug) n'est rendue qu'en développement et occupe
// le coin bas-droite. En local on place le badge juste au-dessus d'elle ($hasDebug) ;
// sinon (qualif, etc.) le badge prend sa place dans le coin bas-droite.
const Badge = styled.div`
   position: fixed;
   bottom: ${props => (props.$hasDebug ? `calc(${spacing()} + 58px + 44px)` : `calc(${spacing()} + 58px)`)};
   right: ${spacing()};
   z-index: 2147650001;
   display: inline-flex;
   align-items: center;
   padding: 4px 10px;
   border-radius: 4px;
   font-size: 12px;
   font-weight: 700;
   letter-spacing: 0.04em;
   color: #fff;
   background-color: ${props => (props.$ioni ? '#4ab543' : '#ff9819')};
   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
   pointer-events: none;

   ${media.tablet`
    bottom: ${props => (props.$hasDebug ? `calc(${spacing()} + 44px)` : spacing())};
  `};
`;

const IoniIndicator = () => {
   const place = useSelector(getSelectedPlace);
   const isImpersonating = useSelector(state => Boolean(state.user.impersonatedUser));

   if (!(isImpersonating || ENVIRONMENT !== 'production') || !place?.id) {
      return null;
   }

   return (
      <Badge $ioni={place.ioniActivated} $hasDebug={ENVIRONMENT === 'development'}>
         {place.ioniActivated ? 'IONI' : 'MAYA'}
      </Badge>
   );
};

export default IoniIndicator;
